var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgComputerLine(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 48,
    viewBox: "0 0 49 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "computer-line"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M10.1001 31.2008H38.9001V11.4008H10.1001V31.2008ZM26.3001 34.8008V38.4008H33.5001V42.0008H15.5001V38.4008H22.7001V34.8008H8.28567C8.04931 34.7994 7.81554 34.7513 7.59778 34.6594C7.38002 34.5675 7.18254 34.4335 7.01666 34.2651C6.85078 34.0967 6.71976 33.8972 6.63111 33.6781C6.54247 33.459 6.49794 33.2245 6.50007 32.9882V9.61338C6.50007 8.61258 7.31907 7.80078 8.28567 7.80078H40.7145C41.7009 7.80078 42.5001 8.60898 42.5001 9.61338V32.9882C42.5001 33.989 41.6811 34.8008 40.7145 34.8008H26.3001Z",
    fill: "#111111"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgComputerLine);
export default __webpack_public_path__ + "static/media/computer-line.ef084a6601e0d159dc4402552b82c771.svg";
export { ForwardRef as ReactComponent };